"use client";

import { lazy } from "react";
import type { ToolUIMeta, ToolUIRegistry } from "../../tool-renderer";

export const magnusPlatformToolsToolRegistry = {
  createSkillFromSandbox: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./skill-card").then(({ CreateSkillFromSandboxToolView }) => ({
        default: CreateSkillFromSandboxToolView,
      }))
    ),
  },
  updateSkillFromSandbox: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./skill-card").then(({ UpdateSkillFromSandboxToolView }) => ({
        default: UpdateSkillFromSandboxToolView,
      }))
    ),
  },
  updateSkillBody: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./skill-card").then(({ UpdateSkillBodyToolView }) => ({
        default: UpdateSkillBodyToolView,
      }))
    ),
  },
  createRoutine: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./routine-card").then(({ CreateRoutineToolView }) => ({
        default: CreateRoutineToolView,
      }))
    ),
  },
  updateRoutine: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./routine-card").then(({ UpdateRoutineToolView }) => ({
        default: UpdateRoutineToolView,
      }))
    ),
  },
  createWorkspace: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./workspace-card").then(({ CreateWorkspaceToolView }) => ({
        default: CreateWorkspaceToolView,
      }))
    ),
  },
  updateWorkspace: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./workspace-card").then(({ UpdateWorkspaceToolView }) => ({
        default: UpdateWorkspaceToolView,
      }))
    ),
  },
  copyFileToWorkspace: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./workspace-card").then(({ CopyFileToWorkspaceToolView }) => ({
        default: CopyFileToWorkspaceToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;

/**
 * Namespaced variant keyed by the progressive-disclosure inner-tool name
 * `magnus-platform-tools_${toolName}`.
 *
 * `magnus-platform-tools` is a progressive-disclosure capability (ADR-057), so
 * its tool calls are dispatched through the `callCapabilityTool` proxy and
 * every durable + live-stream tool part is rewritten to the namespaced inner
 * identity `${capabilityId}_${toolName}` (e.g.
 * `magnus-platform-tools_createSkillFromSandbox`). These entries reuse the same
 * lazy views so the rich skill card renders on the PD path instead of the
 * generic JSON fallback. Wired into the built-in registry in
 * `built-in-registry.ts`.
 */
export const magnusPlatformToolsProgressiveDisclosureToolRegistry: Record<
  string,
  ToolUIMeta
> = Object.fromEntries(
  Object.entries(magnusPlatformToolsToolRegistry).map(([name, meta]) => [
    `magnus-platform-tools_${name}`,
    meta,
  ])
);
